<template>
    <div class="signupPage" >
        <header class="mainHeader">
            <div class="mainHeader__inner">
                <img src="@/assets/tcl2.svg" width="95" height="49" style="vertical-align:middle;">
                <span style="color: white">{{ $t("alexa.tcl_assitant") }}</span>
            </div>
        </header>

        <section class="mainCenter">
            <el-row>
                <el-col :xs="24" :sm="24" :md="6">
                    <div class="things-to-try">
                        <h2> {{ $t("alexa.empty_message") }} </h2>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12">
                    <p class="active_code_hint"> {{ $t("alexa.active_code_hint") }} </p>
                    <div class="active_code_message"> {{ $t("alexa.active_code_message") }}
                    <img src="@/assets/gear.png"  width="14" height="14" style="vertical-align:middle; background-color: #FFF;"></img>
                        <span class="active_code_message">{{ $t("alexa.active_code_message_path") }}</span>
                        <span class="active_code_message">{{ $t("alexa.active_code_message_part2") }}</span>
                    </div>
                    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
                        <el-form-item prop="activeCode" class="ruleForm">
                            <el-input v-model="input" @keyup.enter.native="handleValidate('ruleForm')" placeholder="Activation Code" v-model.trim="ruleForm.activeCode"></el-input>
                            <el-input type="text" style="display: none"></el-input>
                        </el-form-item>
                        <el-form-item prop="agreements">
                            <el-checkbox-group v-model="ruleForm.agreements">
                            <div>
                            <el-checkbox label="agreement2" @keydown.native.enter="setCheck()">
                                {{ $t("alexa.agreements[1]") }} <a href="javascript:void(0)" @click="loadPrivacy()" target="_blank" style="color: #00F">{{ $t("alexa.privacy_policy") }} </a> {{ $t("alexa.agreements[2]") }}
                            </el-checkbox>
                            </div>
                            </el-checkbox-group>
                        </el-form-item>
                        
                        <el-form-item>
                            <el-button type="primary" @click="handleValidate('ruleForm')" style="width: 100%; font-size: 15px;">{{ $t("alexa.active_code_validate") }}</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6">
                    <div class="things-to-try">
                        <h2> {{ $t("alexa.empty_message") }} </h2>
                    </div>
                </el-col>
            </el-row>
        </section>
    </div>
</template>

<script>

import { ERR_SUCCESS, ERR_TO_AMAZON, ERR_TO_GRANT } from '@/const/consts';
import { Config } from '@/config/config';
import { postLWACode, getOACode } from '@/api/oauth';
import { getToken, store, load } from '@/utils/storage';
import { VALIDATE } from '@/store/modules/skillenable';
import i18n from '@/locale';

import { Message } from 'element-ui';
import queryString from 'query-string';
import 'whatwg-fetch';

const cfg = Config

const saveToStorage = function(data) {
    if (data.client_id) {
        store('client_id', data.client_id)
    }
    if (data.redirect_uri) {
        store('redirect_uri', data.redirect_uri)
    }
    if (data.response_type) {
        store('response_type', data.response_type)
    }
    if (data.scope) {
        store('scope', data.scope)
    }
    if (data.state) {
        store('state', data.state)
    }
}

export default {
    name: 'ActiveCode',
    data: function () {
        return {
            ruleForm: {
                activeCode: '',
                agreements: []
            },
            rules: {
                activeCode: [
                    { validator: this.checkCode, trigger: 'blur' }
                ],
                agreements: [
                    { validator: this.checkAgreements, trigger: 'blur' }
                ]
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        console.info("==>> beforeRouteEnter")
        var params = queryString.parse(location.search)
        saveToStorage(params)
        if (params.code) {
            // 第二次进入
            console.info("==>> postLWACode")
            postLWACode(params.code, getToken()).then(resp => {
                if (resp.data.code == ERR_TO_GRANT) {
                    next({ path: '/grant' });
                } else {
                    console.log(resp.data)
                    next()
                }
            }).catch(error => {
                console.error(error)
                Message.error({message: i18n.t("alexa.active_code_message_exception")})
                next()
            })
        } else {
            next()
        }
    },
    methods: {
        handleValidate(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submit()
                } else {
                    console.info('validate fail');
                }
            });
        },
        submit() {
            var params = {
                validate_code: this.ruleForm.activeCode,
                client_id: load("client_id"),
                response_type: load("response_type"),
                scope: load("scope"),
                redirect_uri: load("redirect_uri"),
                state: load("state"),
            }
            this.$store.dispatch(VALIDATE, params).then(data => {
                switch (data.code) {
                    case ERR_TO_AMAZON:
                        this.getOauthCode(data.token)
                        break;
                    case ERR_TO_GRANT:
                        this.$router.replace({ path: '/grant' });
                        break;
                    default:
                        console.info(data)
                        Message.error({message: this.$t("alexa.active_code_message_wrong")})
                        break;
                }
            }).catch(error => {
                console.log(error)
                Message.warning({message: this.$t("alexa.active_code_message_exception")})
            });
        },

        checkCode(rule, value, callback) {
            console.log("value = " + value)
            if (!value) {
                return callback(new Error(this.$t("alexa.active_code_error_null")));
            }
            setTimeout(() => {
                if (!Number.isInteger(parseInt(value))) {
                    callback(new Error(this.$t("alexa.active_code_error_number")));
                } else if (value.length != 6) {
                    callback(new Error(this.$t("alexa.active_code_error_bits")));
                } else {
                    callback();
                }
            }, 100);
        },

        checkAgreements(rule, value, callback) {
            if (this.ruleForm.agreements.length < 1) {
                return callback(new Error(this.$t("alexa.check_agreements_message")));
            } else {
                callback();
            }
        },

        getUUIDByToken(token) {
            token.slice(4, -23)
        },

        getOauthCode(token) {
            var uuid
            if (cfg.version == "Product") {
                uuid = this.getUUIDByToken(token)
            } else {
                uuid = "735d3f793be6f565c54609411ca7806a8da7e76d"
            }
            var href="https://www.amazon.com/ap/oa?client_id=" + cfg.clientId
                        + "&scope=alexa%3Aall"
                        + "&scope_data=%7B%22alexa%3Aall%22%3A%7B%22productID%22%3A%22" + cfg.productId + "%22%2C%22productInstanceAttributes%22%3A%7B%22deviceSerialNumber%22%3A%22"+ uuid +"%22%7D%7D%7D"
                        + "&response_type=code"
                        + "&state=abcd"
                        + "&redirect_uri=https%3A%2F%2F" + cfg.address
            location.href = href
        },

        setCheck() {
            if (this.ruleForm.agreements.length === 0) {
                this.ruleForm.agreements.push("agreement2")
            } else {
                this.ruleForm.agreements = []
            }
        },

        loadPrivacy() {
            var privacy_url = "/#/privacy-policy";
            var browserLang = (navigator.browserLanguage || navigator.language).toLowerCase();

            if (browserLang.startsWith("zh")) {
                privacy_url = "/#/privacy-policy";
            } else if (browserLang.startsWith("de")) {
                privacy_url = "/#/privacy-policy-de";
            } else if (browserLang.startsWith("en")) {
                privacy_url = "/#/privacy-policy";
            } else if (browserLang.startsWith("fr")) {
                privacy_url = "/#/privacy-policy-fr";
            } else if (browserLang.startsWith("es")) {
                privacy_url = "/#/privacy-policy-es";
            } else if (browserLang.startsWith("it")) {
                privacy_url = "/#/privacy-policy-it";
            } else if (browserLang.startsWith("ja")) {
                privacy_url = "/#/privacy-policy-jp";
            } else if (browserLang.startsWith("pt-br")) {
                privacy_url = "/#/privacy-policy-br";
            }else {
                privacy_url = "/#/privacy-policy";
            }
            //window.location.href = privacy_url;
            window.open(privacy_url)
        }
    },
    mounted() {
        this.$refs.ruleForm.$el.querySelector("input").focus()
    }
}

</script>


// WEBPACK FOOTER //
// src/pages/ActiveCode.vue